import React from "react";
import "../App.css";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import xor from "../xor.png";

const DecryptionView = () => {
  const navigate = useNavigate();

  const firstpage = () => {
    navigate("/page2", {
      state: { hexkey, hexuserInput, KeyValue, userInput },
    });
  };

  const second = () => {
    navigate("/final", {
      state: {
        hexkey,
        hexuserInput,
        KeyValue,
        userInput,
        resultXOR,
      },
    });
  };

  const location = useLocation();
  const userInput = location.state.userInput;
  const KeyValue = location.state.KeyValue;
  const hexuserInput = location.state.hexuserInput;
  const hexkey = location.state.hexkey;

  console.log("ip", hexuserInput);
  console.log("key", hexkey);

  function splitHexInput(hexuserInput) {
    // Remove leading and trailing whitespaces
    hexuserInput = hexuserInput.trim();

    // Remove any extra whitespaces between hex values
    hexuserInput = hexuserInput.replace(/\s+/g, " ");

    // Split the input string into an array of hexadecimal values
    const hexValues = hexuserInput.split(" ");

    // Create a 2D array with 4 elements in each inner array
    const result = [];
    for (let i = 0; i < hexValues.length; i += 4) {
      result.push(hexValues.slice(i, i + 4));
    }

    return result;
  }

  const splitIp = splitHexInput(hexuserInput);
  console.log(splitIp);

  const splitKey = splitHexInput(hexkey);
  console.log(splitKey);

  function xorArrays(array1, array2) {
    // Ensure both input arrays have the same length
    if (array1.length !== array2.length) {
      throw new Error("Input arrays must have the same length");
    }

    // Perform XOR operation on corresponding elements
    const resultArray = [];
    for (let i = 0; i < array1.length; i++) {
      const xorResult = [];
      for (let j = 0; j < array1[i].length; j++) {
        const element1 = parseInt(array1[i][j], 16);
        const element2 = parseInt(array2[i][j], 16);
        const xorValue = element1 ^ element2;
        xorResult.push(xorValue.toString(16).padStart(2, "0"));
      }
      resultArray.push(xorResult);
    }

    return resultArray;
  }

  const resultXOR = xorArrays(splitIp, splitKey);
  console.log(resultXOR);

  const ArrayVisualizer = ({ array, containerId }) => {
    const gridStyle = {
      display: "grid",
      gridTemplateColumns: "repeat(16, minmax(0, 1fr))",
      gap: "1rem",
      marginTop: "1rem",
    };

    // Define a list of colors
    const colors = [
      "bg-blue-200",
      "bg-green-200",
      "bg-yellow-200",
      "bg-pink-200",
    ];

    return (
      <div id={containerId} style={gridStyle}>
        {array.map((innerArray, rowIndex) =>
          innerArray.map((element, colIndex) => {
            const colorIndex =
              Math.floor((rowIndex * array[0].length + colIndex) / 4) %
              colors.length;

            return (
              <div
                key={`${rowIndex}-${colIndex}`}
                className={`border border-solid p-4 text-center w-16 h-16 ${
                  colors[colorIndex] // Apply color based on every 4 elements
                }`}
              >
                {element}
              </div>
            );
          })
        )}
      </div>
    );
  };

  const addSpaceBetweenChars = (value) => {
    if (typeof value === 'string') {
      return value.match(/.{1,2}/g).join(' ');
    } else {
        return String(value).split('').join('');
    }
  };

  return (
    <>
      <div className="mx-auto align-middle justify-cente text-center">
        <h1 className=" font-semibold text-3xl pb-5">Input Whitening</h1>
        <p>
          128 bit plaintext is divided into 4 parts and XORed with Key which is
          also split into 4 parts
        </p>
      </div>
      <div className="ml-10 mr-10">
        <ArrayVisualizer array={splitIp} containerId="splitIp" />
        <div className="grid grid-cols-4 gap-4 pt-3">
          <img
            src={xor}
            alt="xor"
            className="mx-auto"
            height="40px"
            width="40px"
          />
          <img
            src={xor}
            alt="xor"
            className="mx-auto"
            height="40px"
            width="40px"
          />
          <img
            src={xor}
            alt="xor"
            className="mx-auto"
            height="40px"
            width="40px"
          />
          <img
            src={xor}
            alt="xor"
            className="mx-auto"
            height="40px"
            width="40px"
          />
        </div>
        <ArrayVisualizer array={splitKey} containerId="splitKey" />
      </div>
      <div className="text-center pt-10">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    viewBox="0 0 64 64"
    id="down-arrow"
    width="30"
    height="30"
    className="mx-auto block"
  >
    <path
      fill="none"
      stroke="#020202"
      stroke-miterlimit="10"
      stroke-width="4"
      d="M32,61.12l28-28-28,28-28-28"
    ></path>
    <line
      x1="32"
      x2="32"
      y2="61.12"
      fill="none"
      stroke="#020202"
      stroke-miterlimit="10"
      stroke-width="4"
    ></line>
  </svg>
</div>

      <div className="ml-10 mr-10 mt-10">
        <ArrayVisualizer array={resultXOR} containerId="resultXOR" />
      </div>

    <div className="text-center pt-10">
        Result of Input Whitening:
        <table className="border-collapse border border-solid border-gray-400 mx-auto ">
        <thead>
        <tr>
          <th className="border border-solid border-gray-400 p-2">R0</th>
          <th className="border border-solid border-gray-400 p-2">R1</th>
          <th className="border border-solid border-gray-400 p-2">R2</th>
          <th className="border border-solid border-gray-400 p-2">R3</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="border border-solid border-gray-400 p-2">{addSpaceBetweenChars(resultXOR[0])}</td>
          <td className="border border-solid border-gray-400 p-2">{addSpaceBetweenChars(resultXOR[1])}</td>
          <td className="border border-solid border-gray-400 p-2">{addSpaceBetweenChars(resultXOR[2])}</td>
          <td className="border border-solid border-gray-400 p-2">{addSpaceBetweenChars(resultXOR[3])}</td>
        </tr>
      </tbody>
    </table>
        </div>

      <div class="button-holder">
        <div class="prev-button" onClick={firstpage}>
          PREVIOUS
        </div>
        <div class="next-button" onClick={second}>
          NEXT
        </div>
      </div>
    </>
  );
};

export default DecryptionView;
